import { render, staticRenderFns } from "./zb.vue?vue&type=template&id=1587db2c&scoped=true"
import script from "./zb.vue?vue&type=script&lang=js"
export * from "./zb.vue?vue&type=script&lang=js"
import style0 from "./zb.vue?vue&type=style&index=0&id=1587db2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1587db2c",
  null
  
)

export default component.exports